<!--New design-->
<div class="container-fluid">
  <div class="col-md-12" *ngIf="isLoading">
    <app-busy [message]="message"></app-busy>
  </div>
  <div class="row">
    <div style="margin-top:15px; margin-bottom:-10px;">
      <h4><span style="padding-right:10px"></span> <i class="fa fa-edit"></i>Permit Type: <b>{{lblHeading}}</b></h4>
    </div>
  </div>
  <hr />

  <div class="row" style="margin-top:20px;margin-left:0px;margin-right:0px;padding:0px;">
    <div class="col-md-12" style="margin:0px;padding:0px;">
      <form [formGroup]="form" (ngSubmit)="onSubmit(form.value)">
        <!--<div class="row">-->
        <!-- Vehicle Type Options -->

        <div class="row">
          <!-- <div style="margin:0px;padding:0px;" class="col-md-6">
            <div class="col-md-12" style="margin:0px;padding:0px;">
              <div class="col-sm-12">
                <label class="control-label">
                  <strong>Permit Type Code<a class="red-asterik">*</a></strong>
                  <span *ngIf="isDup" class="text-danger">Duplicate Codes are not allowed</span>
                </label>
              </div>

              <div class="col-sm-12">
                <input type="text" name="code" formControlName="code" class="form-control"
                  [ngClass]="{'error':form.controls.code.invalid && form.controls.code.dirty, 'noerror': form.controls.code.valid && form.controls.code.dirty}"
                  title="Codes must be unique. Main sort order if group_code and sort_order not used." />
                <div class="form-control-feedback text-danger text-small"
                  *ngIf="form.controls.code.invalid && form.controls.code.dirty">
                  <p *ngIf="form.controls.code.errors.required">Code is required</p>
                  <p *ngIf="form.controls.code.errors.maxlength">Code must not be more than 12 characters.</p>
                </div>

              </div>
            </div>

          </div> -->
          <div style="margin:0px;padding:0px;" class="col-md-6">
            <div class="col-md-12" style="margin:0px;padding:0px;">
              <div class="col-sm-12">
                <label class="control-label"><strong>Description</strong></label>
              </div>
              <div class="col-sm-12" style="margin:0px;padding:0px;">
                <textarea name="description" formControlName="description" class="form-control" rows="1"
                  style="width: 96%; margin-left: 2%;"
                  [ngClass]="{'error':form.controls.description.invalid && form.controls.description.dirty, 'noerror': form.controls.description.valid && form.controls.description.dirty}"
                  title="Free text description of the entity occurrence."></textarea>
                <div class="form-control-feedback text-danger text-small"
                  *ngIf="form.controls.description.invalid && form.controls.description.dirty">
                  <p *ngIf="form.controls.description.errors.required">Description is required</p>
                  <p *ngIf="form.controls.description.errors.maxlength">Description must not be more than 100
                    characters.</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6" style="margin:0px;padding:0px;">
            <div class="col-12 no-sp" style="margin:5px auto;padding:0px;">
              <div class="row no-sp">

                <div class="col-6">
                  <label class="col-sm-12 control-label"><strong>Product Application Fee Link </strong></label>
                  <div class="col-sm-12">
                    <input type="text" name="application_product_link" formControlName="application_product_link"
                           class="form-control"
                           [ngClass]="{'error':form.controls.application_product_link.invalid && form.controls.application_product_link.dirty, 'noerror': form.controls.application_product_link.valid && form.controls.application_product_link.dirty}"
                           title="A value that will  link to the inventory item and its pricing in the accounting system that represents the application fee for this permit type." />
                    <div class="form-control-feedback text-danger text-small"
                         *ngIf="form.controls.application_product_link.invalid && form.controls.application_product_link.dirty">
                      <p *ngIf="form.controls.application_product_link.errors.maxlength">
                        Account Application Fee must
                        not be more than 20
                        characters.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-6">
                  <label class="col-12 control-label"><strong>Product Permit Fee Link </strong></label>
                  <div class="col-12">
                    <input type="text" name="product_link" formControlName="product_link" class="form-control"
                           [ngClass]="{'error':form.controls.product_link.invalid && form.controls.product_link.dirty, 'noerror': form.controls.product_link.valid && form.controls.product_link.dirty}"
                           title="A value that will link the permit type to the product that represents the permit fee and its pricing in the accounting system." />
                    <div class="form-control-feedback text-danger text-small"
                         *ngIf="form.controls.product_link.invalid && form.controls.product_link.dirty">
                      <p *ngIf="form.controls.product_link.errors.maxlength">
                        Product Permit Fee Link must not be more
                        than 20
                        characters long
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6" style="margin:0px;padding:0px;">
            <div class="col-12 no-sp" style="margin:5px auto;padding:0px;">
              <div class="row no-sp">
                <div class="col-6">
                  <label class="col-sm-12 control-label"><strong>Account Application Fee Link </strong></label>
                  <div class="col-sm-12">
                    <input type="text" name="application_account_link" formControlName="application_account_link"
                           class="form-control"
                           [ngClass]="{'error':form.controls.application_account_link.invalid && form.controls.application_account_link.dirty, 'noerror': form.controls.application_account_link.valid && form.controls.application_account_link.dirty}"
                           title="A value that will link to the account in the accounting system to which the application fee for this permit type will be posted." />
                    <div class="form-control-feedback text-danger text-small"
                         *ngIf="form.controls.application_account_link.invalid && form.controls.application_account_link.dirty">
                      <p *ngIf="form.controls.application_account_link.errors.maxlength">
                        Account Application Fee Link
                        must not be more than 20
                        characters.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-6">
                  <label class="col-sm-12 control-label"><strong>Account Permit Fee Link </strong></label>
                  <div class="col-sm-12">
                    <input type="text" name="account_link" formControlName="account_link" class="form-control"
                           [ngClass]="{'error':form.controls.account_link.invalid && form.controls.account_link.dirty, 'noerror': form.controls.account_link.valid && form.controls.account_link.dirty}"
                           title="A value that will link the permit type to the relevant account in the accounting system to which the permit fee will be posted.." />
                    <div class="form-control-feedback text-danger text-small"
                         *ngIf="form.controls.account_link.invalid && form.controls.account_link.dirty">
                      <p *ngIf="form.controls.account_link.errors.maxlength">
                        Account Permit Fee Link must not be more
                        than 20
                        characters.
                      </p>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div class="col-6" style="margin:0px;padding:0px;">
            <div class="col-12 no-sp" style="margin:5px auto;padding:0px;">
              <div class="row no-sp">
                <div class="col-6">
                  <label class="control-label col-12" style="margin:0px auto 0px;">
                    <strong>Application Fee&nbsp;</strong>
                  </label>
                  <div class="col-12" style="margin-top:0px;padding-top:0px;">
                    <input type="number" name="current_application_fee" min="0"
                      formControlName="current_application_fee" class="form-control" style=""
                      title="May be used to hold the current fee for the type of permit if not held solely in the accounting system.">
                  </div>
                </div>
                <div class="col-6">
                  <label class="control-label col-12" style="margin:0px auto 0px;">
                    <strong>Permit Fee&nbsp;</strong>
                  </label>
                  <div class="col-12" style="">
                    <input type="number" name="current_fee" min="0" formControlName="current_fee" class="form-control"
                      style=""
                      title="May be used to hold the current fee for the type of permit if not held solely in the accounting system.">
                  </div>
                </div>

              </div>
            </div>
          </div>

          <div class="col-6" style="margin:0px;padding:0px;">
            <div class="col-12 no-sp" style="margin:5px auto;padding:0px;">
              <div class="row no-sp">
                <div class="col-6">
                  <label class="control-label col-12" style="margin:0px auto 0px;">
                    <strong>Permit Type Category<a class="red-asterik">*</a>&nbsp;</strong>
                  </label>
                  <div class="col-12" style="">
                    <select class="form-control" id="freight_passenger_ind" [(ngModel)]="selectedCat"
                      name="freight_passenger_ind" formControlName="freight_passenger_ind" style="width:100%;"
                      title="Categorises the permit as a freight versus passenger permit.">
                      <option *ngFor="let cat of listCats" [ngValue]="cat.key">{{cat.value}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-6">
                  <label class="control-label col-12" style="margin:0px auto 0px;">
                    <strong>Permit Type Period<a class="red-asterik">*</a>&nbsp;</strong>
                  </label>
                  <div class="col-12" style="margin-top:0px;padding-top:0px;">
                    <select class="form-control" id="temp_long_ind" [(ngModel)]="selectedPer" name="temp_long_ind"
                      formControlName="temp_long_ind" style="width:100%;"
                      title="Indicates where it is used on dropdowns or lists.">
                      <option *ngFor="let per of listPers" [ngValue]="per.key">{{per.value}}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div class="col-6" style="margin:0px;padding:0px;">
            <div class="col-12 no-sp" style="margin:5px auto;padding:0px;">
              <div class="row no-sp">
                <div class="col-6">
                  <label class="control-label col-12" style="margin:0px auto 0px;">
                    <strong>Permit Days&nbsp;</strong>
                  </label>
                  <div class="col-12" style="">
                    <input type="number" (blur)="checkPeriod('permit_days',1)" onkeydown="return event.keyCode !== 69"
                      name="permit_days" min="0" formControlName="permit_days" class="form-control" style=""
                      title="The number of days for which the permit is valid from activation or start date. One and only one of permit days, permit months and permit years should be non-zero.">
                    <div class="form-control-feedback text-danger text-small"
                      *ngIf="form.controls.permit_days.invalid && form.controls.permit_days.dirty">
                      <p *ngIf="form.controls.permit_days.errors.checkInt">Invalid number of days</p>
                    </div>
                  </div>
                </div>
                <div class="col-6">
                  <label class="control-label col-12" style="margin:0px auto 0px;">
                    <strong>Permit Months &nbsp;</strong>
                  </label>
                  <div class="col-12" style="margin-top:0px;padding-top:0px;">
                    <input type="number" (blur)="checkPeriod('permit_months',2)" onkeydown="return event.keyCode !== 69"
                      name="permit_months" min="0" formControlName="permit_months" class="form-control" style=""
                      title="The number of months for which the permit is valid from activation or start date. One and only one of permit days, permit months and permit years should be non-zero.">
                    <div class="form-control-feedback text-danger text-small"
                      *ngIf="form.controls.permit_months.invalid && form.controls.permit_months.dirty">
                      <p *ngIf="form.controls.permit_months.errors.checkInt">Invalid number of months</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div class="col-6" style="margin:0px;padding:0px;">
            <div class="col-12 no-sp" style="margin:5px auto;padding:0px;">
              <div class="row no-sp">
                <div class="col-6">
                  <label class="control-label col-12" style="margin:0px auto 0px;">
                    <strong>Permit Years</strong>
                  </label>   
              <div class="col-sm-12">
              <input type="number" (blur)="checkPeriod('permit_years',3)" onkeydown="return event.keyCode !== 69"
                name="permit_years" min="0" formControlName="permit_years" class="form-control"
                [ngClass]="{'error':form.controls.permit_years.invalid && form.controls.permit_years.dirty, 'noerror': form.controls.permit_years.valid && form.controls.permit_years.dirty}"
                style=""
                title="The number of years for which the permit is valid from activation or start date. One and only one of permit days, permit months and permit years should be non-zero.">
              <div class="form-control-feedback text-danger text-small"
                *ngIf="form.controls.permit_years.invalid && form.controls.permit_years.dirty">
                <p *ngIf="form.controls.permit_years.errors.checkInt">Invalid number of years</p>
              </div>

                 </div>
                </div>
                <div class="col-6">
                  <div class="col-sm-12">
                    <table style="width: 100%; vertical-align: middle;">
                      <tr>
                        <td> <label><strong style="">User must specify duration?&nbsp; </strong></label></td>
                        <td align="right">
                          <input class="form-control input-sm" type="checkbox" value="can_specify_duration"
                            formControlName="can_specify_duration"
                            title="`Must the carrier specify the permit duration ?">
                        </td>
                      </tr>
                    </table>
                    </div>
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="col-md-6" style="margin:0px;padding:0px;">
            <div class="col-sm-12">
              <label class="control-label">
                <strong>Permit Years</strong>
              </label>
            </div>

          </div>

          <div class="col-6" style="margin:0px; padding:0px;">
            <div class="col-12 no-sp" style="margin:0px auto;padding:0px;">

            </div>
          </div> -->



        </div>
        <!--</div>-->
        <!--</div>-->
        <br />
        <!-- Configuration Rules-->
        <div class="col-12">
          <fieldset class="scheduler-border" style="margin:0px;padding:0px;">
            <legend class="scheduler-border tsk-display blackcontrol">Configuration Rules for Permits</legend>
            <div class="col-md-12 no-sp" style="margin:5px auto;padding:0px;">
              <div class="row">
                <div class="col-md-3">
                  <div class="form-check form-check-inline" style="position: relative; width: 100%;">
                    <br />
                    <br />
                    <table style="width: 100%;">
                      <tr>
                        <td><label><strong style="">Is it a Permit?&nbsp; </strong></label></td>
                        <td align="right"><input class="form-control input-sm" type="checkbox" value="is_permit"
                            formControlName="is_permit"
                            title="Indicates if the permit_type is for an actual permit (as opposed to a renewal or change). On document it can indicate if the document is an electronic permit.">
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
                <div class="col-md-3">
                  <label class="control-label col-12" style="margin:0px;padding:0px;">
                    <strong>Charge Permit Fee When &nbsp;</strong>
                  </label>
                  <div class="col-12" style="margin:0px;padding:0px;">
                    <select class="form-control" name="charge_when_ind" formControlName="charge_when_ind"
                      style="width:100%;" title="form-control"
                      title="Indicates when the application and permit fee should be charged to the carrier: 0=None; 1=Application fee on submission; 2=Application and permit fees on submission">
                      <option value="0">None</option>
                      <option value="1">Application fee on submission</option>
                      <option value="2">Application and permit fees on submission</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-3">
                  <label class="control-label col-12" style="margin:0px;padding:0px;">
                    <strong>Number Of Renewals Allowed &nbsp;</strong>
                  </label>
                  <div class="col-12" style="margin:0px;padding:0px;">
                    <input type="number" name="num_renewals_allowed" min="0" formControlName="num_renewals_allowed"
                      class="form-control" title="The number of renewals allowed for this type of permit.">
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-check form-check-inline" style="position: relative; width: 100%;">
                    <br />
                    <br />
                    <table style="width: 100%;">
                      <tr>
                        <td> <label><strong style="">Can supply own route?&nbsp; </strong></label></td>
                        <td align="right">
                          <input class="form-control input-sm" type="checkbox" value="can_amend_route"
                            formControlName="can_amend_route"
                            title="Can the carrier request a change to the route for this type of permit?">
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-check form-check-inline" style="position: relative; width: 100%;">
                    <br />
                    <br />
                    <table style="width: 100%;">
                      <tr>
                        <td><label><strong style="">Must provide a timetable?&nbsp; </strong></label></td>
                        <td align="right">
                          <input class="form-control input-sm" type="checkbox" value="timetable_reqd"
                            formControlName="timetable_reqd"
                            title="Must provide a timetable.">
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-check form-check-inline" style="position: relative; width: 100%;">
                    <br />
                    <br />
                    <table style="width: 100%;">
                      <tr>
                        <td><label><strong style="">Must own the vehicle?&nbsp; </strong></label></td>
                        <td align="right">
                          <input class="form-control input-sm" type="checkbox" value="own_vehicle_reqd"
                            formControlName="own_vehicle_reqd"
                            title="Must the applicant own their own vehicle to apply for this type of permit.">
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-check form-check-inline" style="position: relative; width: 100%;">
                    <br />
                    <br />
                    <table style="width: 100%;">
                      <tr>
                        <td><label><strong style="">Must belong to a transport association?&nbsp; </strong></label></td>
                        <td align="right">
                          <input class="form-control input-sm" type="checkbox" value="association_reqd"
                            formControlName="association_reqd"
                            title="Must the applicant belong to a transport association to qualify for this type of permit.">
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-check form-check-inline" style="position: relative; width: 100%;">
                    <br />
                    <br />
                    <table style="width: 100%;">
                      <tr>
                        <td><label><strong style="">All permits on application must have same start date?&nbsp; </strong></label></td>
                        <td align="right">
                          <input class="form-control input-sm" type="checkbox" value="one_start_date_reqd"
                            formControlName="one_start_date_reqd"
                            title="All permits on application must have same start date.">
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="form-check form-check-inline" style="position: relative; width: 100%;">
                    <br />
                    <br />
                    <table style="width: 100%;">
                      <tr>
                        <td><label><strong style="">Can Create Permit? <a class="red-asterik">*</a>&nbsp; </strong></label></td>
                        <td align="right">
                          <input class="form-control input-sm" type="checkbox" value="canCreatePermit"
                            formControlName="canCreatePermit"
                            title="Can Create Permit">
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>

                <div class="col-md-3">
                  <label class="control-label col-12" style="margin:0px;padding:0px;">
                    <strong>Permit Template  <a class="red-asterik">*</a> &nbsp;</strong>
                  </label>
                  <div class="col-12" style="margin:0px;padding:0px;">
                    <select class="form-control" name="PermitTemplate" formControlName="PermitTemplate"
                      style="width:100%;" title="form-control"
                      title="Indicates the template to use when printing permit">
                      <option value="Permit">Permit</option>
                      <option value="Permit_Bus">Bus</option>
                      <option value="Compliance">Compliance</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-3" *ngIf="form.controls.permit_years.value == 5">
                  <div class="form-check form-check-inline" style="position: relative; width: 100%;">
                    <br />
                    <br />
                    <table style="width: 100%;">
                      <tr>
                        <td><label><strong style="">Is Compliance Permit?&nbsp; </strong></label></td>
                        <td align="right">
                          <input class="form-control input-sm" type="checkbox" value="isCompliancePermitType"
                            formControlName="isCompliancePermitType"
                            title="Is Compliance Permit">
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>

                <div class="col-md-3" *ngIf="form.controls.isCompliancePermitType.value == true">
                  <label class="control-label col-12" style="margin:0px;padding:0px;">
                    <strong>Compliance Permit Type &nbsp;</strong>
                  </label>
                  <div class="col-12" style="margin:0px;padding:0px;">
                    <select class="form-control" name="Compliance_PermitType_Id" formControlName="Compliance_PermitType_Id"
                      style="width:100%;" title="form-control"
                      title="Indicates the compliance permit type">
                      <option value="0">None</option>
                      <option *ngFor="let ptype of permitTypeList" [ngValue]="ptype.id">{{ptype.description}}</option>
                     
                    </select>
                  </div>
                </div>

              </div>
            </div>
          </fieldset>
        </div>
        <div class="col-12">
          <fieldset class="scheduler-border" style="margin:0px;padding:0px;">
            <legend class="scheduler-border tsk-display blackcontrol">Configuration Rules for Returns
            </legend>
            <div class="col-md-12 no-sp" style="margin:5px auto;padding:0px;">
              <div class="row">
                <div class="col-md-3">
                  <div class="form-check form-check-inline" style="position: relative; width: 100%;">
                    <br />
                    <br />
                    <table style="width: 100%;">
                      <tr>
                        <td><label><strong style="">Must Submit Monthly Return?&nbsp; </strong></label></td>
                        <td align="right">
                          <input class="form-control input-sm" type="checkbox" value="monthly_return_reqd"
                            formControlName="monthly_return_reqd"
                            title="Must the carrier submit a monthly passenger or manifest report for this type of permit?">
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-check form-check-inline" style="position: relative; width: 100%;">
                    <br />
                    <br />
                    <table style="width: 100%;">
                      <tr>
                        <td><label><strong style="">Must Submit Annual Compliance?&nbsp; </strong></label></td>
                        <td align="right">
                          <input class="form-control input-sm" type="checkbox" value="annual_compliance_reqd"
                            formControlName="annual_compliance_reqd"
                            title="Must the carrier submit an annual compliance report for this type of permit? ">
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-check form-check-inline" style="position: relative; width: 100%;">
                    <br />
                    <br />
                    <table style="width: 100%;">
                      <tr>
                        <td><label><strong style="">Must Return The Certificate?&nbsp; </strong></label></td>
                        <td align="right">
                          <input class="form-control input-sm" type="checkbox" value="certificate_return_reqd"
                            formControlName="certificate_return_reqd"
                            title="Must the carrier return the printed permit and annexures for this type of permit?">
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
        <div class="col-12">
          <fieldset class="scheduler-border" style="margin:0px;padding:0px;">
            <legend class="scheduler-border tsk-display blackcontrol">Configuration Rules for Changes and Duplicates</legend>
            <div class="col-md-12 no-sp" style="margin:5px auto;padding:0px;">
              <div class="row">
                <div class="col-md-3">
                  <div class="form-check form-check-inline" style="position: relative; width: 100%;">
                    <br />
                    <br />
                    <table style="width: 100%;">
                      <tr>
                        <td><label><strong style="">Duplicate Permit Allowed?&nbsp; </strong></label></td>
                        <td align="right"><input class="form-control input-sm" type="checkbox" value="can_get_duplicate"
                            formControlName="can_get_duplicate"
                            title="Can a duplicate be issued for this type of permit?"></td>
                      </tr>
                    </table>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-check form-check-inline" style="position: relative; width: 100%;">
                    <br />
                    <br />
                    <table style="width: 100%;">
                      <tr>
                        <td> <label><strong style="">Replacement Vehicle Allowed?&nbsp; </strong></label></td>
                        <td align="right"> <input class="form-control input-sm" type="checkbox"
                            value="can_replace_vehicle" formControlName="can_replace_vehicle"
                            title="Can the carrier request to replace the vehicle for this type of permit?"></td>
                      </tr>
                    </table>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-check form-check-inline" style="position: relative; width: 100%;">
                    <br />
                    <br />
                    <table style="width: 100%;">
                      <tr>
                        <td><label><strong style="">Ownership Change Allowed?&nbsp; </strong></label></td>
                        <td align="right">
                          <input class="form-control input-sm" type="checkbox" value="can_amend_owner "
                            formControlName="can_amend_owner"
                            title="Can the carrier request a change of ownership for this type of permit?">
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-check form-check-inline" style="position: relative; width: 100%;">
                    <br />
                    <br />
                    <table style="width: 100%;">
                      <tr>
                        <td> <label><strong style="">Error Correction Allowed?&nbsp; </strong></label></td>
                        <td align="right"> <input class="form-control input-sm" type="checkbox"
                            value="can_correct_error" formControlName="can_correct_error"
                            title="Can the carrier request a correction on this type of permit?">
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-check form-check-inline" style="position: relative; width: 100%;">
                    <br />
                    <br />
                    <table style="width: 100%;">
                      <tr>
                        <td><label><strong style="">Annexure Changes Allowed?&nbsp; </strong></label></td>
                        <td align="right">
                          <input class="form-control input-sm" type="checkbox" value="can_change_annexure"
                            formControlName="can_change_annexure"
                            title="Can the carrier request a change in the annexure for this type of permit?">
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-check form-check-inline" style="position: relative; width: 100%;">
                    <br />
                    <br />
                    <table style="width: 100%;">
                      <tr>
                        <td><label><strong style="">Timetable Changes Allowed?&nbsp; </strong></label></td>
                        <td align="right">
                          <input class="form-control input-sm" type="checkbox" value="can_amend_timetable"
                            formControlName="can_amend_timetable"
                            title="Can the carrier request to amend the timetable for this type of permit?">
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-check form-check-inline" style="position: relative; width: 100%;">
                    <br />
                    <br />
                    <table style="width: 100%;">
                      <tr>
                        <td><label><strong style="">Route Changes Allowed?&nbsp; </strong></label></td>
                        <td align="right">
                          <input class="form-control input-sm" type="checkbox" value="can_amend_route"
                            formControlName="can_amend_route"
                            title="Can the carrier request to amend the Route for this type of permit?">
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
        <!-- Sorting and Displaying -->
        <div class="col-12">
          <fieldset class="scheduler-border" style="margin:0px;padding:0px;">
            <legend class="scheduler-border tsk-display blackcontrol">Sorting And Displaying</legend>
            <div class="col-md-12 no-sp" style="margin:5px auto;padding:0px;">
              <div class="row">
                <div class="col-md-3">
                  <label class="control-label col-12" style="margin:0px;padding:0px;">
                    <strong class="" style="width:110px;">Sort Order<a class="red-asterik">*</a>&nbsp; </strong>
                  </label>
                  <div class="col-12" style="margin:0px;padding:0px;">
                    <select id="sort_order" class="form-control" name="sort_order" formControlName="sort_order"
                      style="width:100%;"
                      title="Allows user to put in a sorting code. By default, all rows will have sort_order 1.">
                      <option *ngFor="let rank of utility.sortOrderList" [ngValue]="rank" [selected]="0">{{rank}}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-3">
                  <label class="control-label col-12" style="margin:0px;padding:0px;">
                    <strong>Group Code<a class="red-asterik">*</a>&nbsp; </strong>
                  </label>
                  <div class="col-12" style="margin:0px;padding:0px;">
                    <input type="text" class="form-control" name="group_code" formControlName="group_code"
                      style="width:100%;"
                      [ngClass]="{'error':form.controls.group_code.invalid && form.controls.group_code.dirty, 'noerror': form.controls.group_code.valid && form.controls.group_code.dirty}"
                      title="Allows user to group codes. By default, all rows will belong to group A.">
                    <div class="form-control-feedback text-danger text-small"
                      *ngIf="form.controls.group_code.invalid && form.controls.group_code.dirty">
                      <p *ngIf="form.controls.group_code.errors.required">Group Code is required</p>
                      <p *ngIf="form.controls.group_code.errors.maxlength">Group Code must not be more than 12
                        characters.</p>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <label class="control-label col-12" style="margin:0px;padding:0px;">
                    <strong style="">Display When<a class="red-asterik">*</a>&nbsp; </strong>
                  </label>
                  <div class="col-12" style="margin:0px;padding:0px;">
                    <select class="form-control" id="display_ind" [(ngModel)]="selectedDisplay" name="display_ind"
                      formControlName="display_ind" style="width:100%;"
                      title="Indicates where it is used on dropdowns or lists.">
                      <option *ngFor="let ind of utility.displayIndicators" [ngValue]="ind.key">{{ind.value}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-check form-check-inline" style="padding-top: 15px;">
                    <br />
                    <br />
                    <label><strong style="">Active?&nbsp; </strong></label>
                    <input class="form-control input-sm" type="checkbox" id="is_active" value="is_active"
                      formControlName="is_active"
                      title="An indicator to control if the row will appear on a list or in a search. Can be used to indicate logically deleted.">
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
        <!-- End of Sorting and Displayings -->
        <div class="col-md-12" style="margin-top:10px;padding-top:10px; font-size:11px;">
          <dl style="width:460px;">
            <dt style="width:40px;">Created</dt>
            <dd [innerHTML]="audit.created"></dd>
            <dt style="width:46px;">Updated</dt>
            <dd [innerHTML]="audit.updated"></dd>
          </dl>
        </div>
        <!-- End -->
        <hr>
        <div class="col-md-12" style="margin:0px;padding:0px;">
          <br>
          <button title="Save change(s)" type="submit" id="btnSave" [disabled]="enableSubmit()"
            class="btn btn-md btn-success pull-right" style="width:10%; margin-left:10px; "><i class="fa fa-save"></i>
            Save</button>
          <button title="Go Back" type="button" id="btnCancel" [routerLink]="['/permit/type/list']"
            class="btn btn-md btn-info pull-right" style="width:10%; margin-left:10px; "><i
              class="fa fa-arrow-circle-left"></i> Back</button>
        </div>
      </form>
    </div>
  </div>
</div>
<!--End new design -->
